
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/wheels",
      function () {
        return require("private-next-pages/wheels/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/wheels"])
      });
    }
  